'use strict';

class EFaktura {
  constructor($sce, originatorService) {
    this.$sce = $sce;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.agreement = {};
    this.name = null;
    this.status = false;

    this.load();
  }

  load() {
    this.originatorService.getEFaktura2()
      .then((resp) => {
        this.agreement = resp.data;

        if (resp.status === 204) {
          this.status = false;
        } else {
          this.status = true;
        }
      });
  }

  getStatus(text) {
    const strings = {
      ACTIVE: '<i class="fa fa-check"></i> aktiv',
      DELETED: '',
      INACTIVE: '<i class="fa fa-times"></i> inaktiv',
      PENDING: '',
      INVALID: ''
    };

    if (text && strings[text]) {
      return this.$sce.trustAsHtml(strings[text]);
    }
  }

  register() {
    this.originatorService.registerEFaktura2(this.name)
      .then(() => this.load());
  }

  removeAgreement() {
    swal({
      title: 'Er du sikker?',
      type: 'warning',
      confirmButtonColor: '#004b8d',
      confirmButtonText: 'Bekreft',
      showCancelButton: true,
      cancelButtonText: 'Avbryt'
    }, () => {
      this.originatorService.deleteEFaktura2(this.name)
        .then(() => this.load());
    }, this);
  }
}

EFaktura.$inject = ['$sce', 'originatorService'];

const eFaktura = {
  require: {
    accountIntegrations: '^^accountIntegrations'
  },
  controller: EFaktura,
  template: `
    <h3 class="subheader">eFaktura</h3>

    <fieldset>
      <div class="row">
        <div class="large-3 columns">
          <img src="/assets/img/efaktura.jpg" alt="eFaktura" />
        </div>

        <div class="large-9 columns" ng-hide="$ctrl.status">
          <p>Med eFaktura kan du sende regninger rett til nettbanken til kundene dine.</p>

          <p>For å bestille eFaktura må du ha fullmakt til å bestille tjenester på vegne av den som eier SendRegning-kontoen. Hvis du har det, fyller du bare inn navnet ditt i feltet under og trykker "Bestill eFaktura". Når dette er klart, vil eFaktura komme opp som mulig forsendelsesmåte for mottagere som kan ta i mot eFaktura.</p>

          <p>For å identifisere eFaktura-mottagere best mulig, bør du oppgi fullt navn, e-postadresse og telefonnummer på hver kunde. </p>

          <div>
            <label for="name">Navn</label>
            <input type="text" name="name" id="name" ng-model="$ctrl.name">

            <label for="accept">
              <input type="checkbox" id="accept" ng-model="$ctrl.accept"> Jeg godtar <a href="/files/eFaktura_B2C_avtalevilkar.pdf" target="_blank">vilkårene for bruk</a> av eFaktura
            </label>

            <button class="button" ng-click="$ctrl.register()" ng-disabled="!$ctrl.accept">Bestill eFaktura</button>
          </div>
        </div>

        <div class="large-9 columns" ng-show="$ctrl.status">
          <p>
            Status: <span ng-bind-html="$ctrl.getStatus($ctrl.agreement.status)"></span><br>
            Dato: {{ $ctrl.agreement.registrationDate | dateFormat }}<br>
            Organisasjonsnummer: <b>{{ $ctrl.agreement.organisationNumber | organisationNumberFormat }}</b>
          </p>
          <p><a href="/files/eFaktura_B2C_avtalevilkar.pdf" target="_blank">Vilkår for bruk</a></p>

          <a href ng-click="$ctrl.removeAgreement()" class="button secondary">Avslutt avtale</a>
        </div>
      </div>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('efaktura', eFaktura);
